import loadable from "@loadable/component";
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import FormBuilderPage from "./Pages/FormBuilderPage/FormBuilderPage";
import ResourcesViewsPage from "./Pages/ResourcesViewsPage/ResourcesViewsPage";
import { RoutePath } from "./Utils/RoutePath";
import CreateUserPage from "./Pages/CreateUserPage/CreateUserPage";
// import EdiEcubePage from "./Pages/EdiEcubePage/EdiEcubePage";
import ForgotPasswordPage from "./Pages/ForgotPasswordPage/ForgotPasswordPage";
import ResetPasswordPage from "./Pages/ResetPasswordPage/ResetPasswordPage";
import LinkedResources from "./Pages/ResourcesViewsPage/LinkedResources/LinkedResources";
import FieldList from "./Pages/ResourcesViewsPage/FieldList/FieldList";
import FiltersOnFields from "./Pages/ResourcesViewsPage/FiltersOnFields/FiltersOnFields";
import OrdinancesPage from "./Pages/ResourcesViewsPage/Ordinances/OrdinancesPage";
import ResourceViewPage from "./Pages/ResourcesViewsPage/ResourceViewPage";
import ResourceViewPageNew from "./Pages/ResourcesViewsPage/ResourceViewPageNew";
import LinkedResourcesEdit from "./Pages/ResourcesViewsPage/LinkedResources/LinkedResourcesEdit";
import FieldListEdit from "./Pages/ResourcesViewsPage/FieldList/FieldListEdit";
import FiltersOnFieldsEdit from "./Pages/ResourcesViewsPage/FiltersOnFields/FiltersOnFieldsEdit";
import OrdinanancesEdit from "./Pages/ResourcesViewsPage/Ordinances/OrdinanancesEdit";
import LoginExtPage from "./Pages/LoginExtPage/LoginExtPage";
import LoginGeafPage from "./Pages/LoginGeafPage/LoginGeafPage";
import Impersonate from "./Pages/Impersonate/Impersonate";

const LoginPage = loadable(() => import("./Pages/LoginPage/LoginPage"));
const HomePage = loadable(() => import("./Pages/HomePage/HomePage"));
const LogoutPage = loadable(() => import("./Pages/LogoutPage/LogoutPage"));
const ProfilePage = loadable(() => import("./Pages/ProfilePage/ProfilePage"));
const ChangeCompanyPage = loadable(
  () => import("./Pages/ChangeCompanyPage/ChangeCompanyPage")
);
const ChangeUserProductPage = loadable(
  () => import("./Pages/ChangeUserProductPage/ChangeUserProductPage")
);
const ChangePasswordPage = loadable(
  () => import("./Pages/ChangePasswordPage/ChangePasswordPage")
);
const MagautoDocumentsSentPage = loadable(
  () => import("./Pages/MagautoDocumentsSentPage/MagautoDocumentsSentPage")
);

const DocPortalPage = loadable(
  () => import("./Pages/DocPortalPage/DocPortalPage")
);

type Props = {};

const PortalRoutes = (props: Props) => {
  console.log("PortalRoutes");
  return (
    <>
      <Routes>
        <Route path={RoutePath.LOGIN} element={<LoginPage />} />
        <Route path={RoutePath.LOGIN_GEAF} element={<LoginGeafPage />} />
        <Route path={RoutePath.HOME} element={<HomePage />} />

        <Route path={RoutePath.PROFILE} element={<ProfilePage />} />

        <Route path={RoutePath.LOGOUT} element={<LogoutPage />} />

        <Route
          path={RoutePath.CHANGE_COMPANY}
          element={<ChangeCompanyPage />}
        />
        <Route
          path={RoutePath.CHANGE_USER_PRODUCT}
          element={<ChangeUserProductPage />}
        />

        <Route
          path={RoutePath.CHANGE_PASSWORD}
          element={<ChangePasswordPage />}
        />

        <Route
          path={RoutePath.DOCUMENTS_SENT}
          element={<MagautoDocumentsSentPage />}
        />

        <Route path={`${RoutePath.IMPERSONATE}`} element={<Impersonate />} />

        <Route path={RoutePath.CREATE_FORM} element={<FormBuilderPage />} />

        <Route path={RoutePath.CREATE_USER} element={<CreateUserPage />} />

        <Route
          path={RoutePath.RESOURCES_VIEWS}
          element={<ResourcesViewsPage />}
        />

        <Route
          path={`${RoutePath.RESOURCES_VIEWS}/new`}
          element={<ResourceViewPageNew />}
        />

        {/* Nested Routes */}
        <Route
          path={`${RoutePath.RESOURCES_VIEWS}/:View_ID`}
          element={<ResourceViewPage />}
        >
          <Route path={"linked_resources"} element={<LinkedResources />}>
            <Route path={"edit"} element={<LinkedResourcesEdit />} />
          </Route>

          <Route path={"field_list"} element={<FieldList />}>
            <Route path={"edit"} element={<FieldListEdit />} />
          </Route>

          <Route path={"fiters_on_fields"} element={<FiltersOnFields />}>
            <Route path={"edit"} element={<FiltersOnFieldsEdit />} />
          </Route>

          <Route path={"ordinances"} element={<OrdinancesPage />}>
            <Route path={"edit"} element={<OrdinanancesEdit />} />
          </Route>
        </Route>

        <Route
          path={RoutePath.FORGOT_PASSWORD}
          element={<ForgotPasswordPage />}
        />

        <Route
          path={RoutePath.RESET_PASSWORD}
          element={<ResetPasswordPage />}
        />

        <Route path={RoutePath.LOGIN_EXT} element={<LoginExtPage />} />

        <Route path={RoutePath.DOCUMENTS_PORTAL} element={<DocPortalPage />} />

        <Route path="*" element={<Navigate to={RoutePath.LOGIN} />} />
      </Routes>
    </>
  );
};

export default PortalRoutes;
